var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5 7a5 5 0 0 1 -3.65 4.81 4.64 4.64 0 0 1 -1.35.19 5 5 0 0 1 -2-9.59 4.87 4.87 0 0 1 2-.41 5 5 0 0 1 5 5z",
    fill: "#1e88e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 22.44a.55.55 0 0 1 -.5.56h-20a.5.5 0 0 1 -.5-.5 9.47 9.47 0 0 1 9.44-9.5h2.34a9.46 9.46 0 0 1 9.22 9.44z",
    fill: "#1e88e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.85 11.81a5 5 0 0 0 -1.35-9.81 4.87 4.87 0 0 0 -2 .41 13.89 13.89 0 0 1 3.34 9.07c.02.11.02.22.01.33z",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.78 13a14 14 0 0 1 -6 10h14.72a.55.55 0 0 0 .5-.56 9.46 9.46 0 0 0 -9.22-9.44z",
    fill: "#1976d2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0d47a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.5 12a5 5 0 1 1 5-5 5 5 0 0 1 -5 5zm0-9a4 4 0 1 0 4 4 4 4 0 0 0 -4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5 23h-20a.5.5 0 0 1 -.5-.5 9.47 9.47 0 0 1 9.44-9.5h2.12a9.46 9.46 0 0 1 9.44 9.44.55.55 0 0 1 -.5.56zm-19.5-1h19a8.46 8.46 0 0 0 -8.43-8h-2.13a8.46 8.46 0 0 0 -8.44 8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile_active.2f39258fd7cde6a291fd09312c8e6be0.svg";
export { ForwardRef as ReactComponent };